import React, { useContext, useRef } from "react";

const ParticipantContext = React.createContext();

const useCourseCountMapping = () => useContext(ParticipantContext);

const ParticipantProvider = ({ children }) => {
  const courseCountMappingRef = useRef({});

  return (
    <ParticipantContext.Provider value={courseCountMappingRef}>
      {children}
    </ParticipantContext.Provider>
  );
};

export { ParticipantContext, ParticipantProvider, useCourseCountMapping };
